import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const shapesWordList = [
  "angle",
  "arrow",
  "circle",
  "coil",
  "corner",
  "cube",
  "curve",
  "diamond",
  "edge",
  "flat",
  "fold",
  "heart",
  "hollow",
  "horizontal",
  "line",
  "loop",
  "oval",
  "overlap",
  "parallel",
  "point",
  "pyramid",
  "rectangle",
  "rough",
  "round",
  "sharp",
  "smooth",
  "square",
  "star",
  "straight",
  "surface",
  "triangle",
  "twist",
  "vertical",
  "volume",
  "wave",
];

export const shapesCollection: WordCollection = createCollection(
  "shapes",
  "Shapes & Patterns",
  shapesWordList,
  { icon: "shape", isWordlistViewable: true },
);
